// import PostsRepository from "./modules/posts";
import UserAccountRepository from "./modules/user-account";
import ServiceAccountsRepository from "./modules/service-accounts";
import OrganizationsRepository from "./modules/organizations";
import AsigProjectsRepository from "./modules/asig-projects";
// import DummyPostsRepository from "./modules/dummy-posts";
// import DummyMonitoringDevice from "./modules/dummy-monitoring-device";
import { MonitoringDevicesRepository } from "./modules/monitoring-devices";
import { MabeeemlMonitoringDevicesRepository } from "./modules/mabeeeml-monitoring-devices";
// import DummyMonitoringTargetsRepository from "./modules/dummy-monitoring-targets";
import MonitoringTargetsRepository from "./modules/monitoring-targets";
import { MonitoringSettingsRepository } from "./modules/monitoring-settings";
import { AscmuMonitoringSettingsRepository } from "./modules/ascmu-monitoring-settings";
import { ContactMonitoringEventRulesRepository } from "./modules/contact-monitoring-event-rules";
// import DummyNotificationRecipients from "./modules/dummy-notification-recipients";
import NotificationRecipients from "./modules/notification-recipients";
import { BilingsRepository } from "./modules/billings";
// import DummyServiceAccount from "./modules/dummy-service-account";
import { SignUpRepository } from "./modules/sign-up";
import { ResetPasswordRepository } from "./modules/reset-password";
import { AscmuSubscriptionsRepository } from "./modules/ascmu-subscriptions";

import { PostcodeJpRepository } from "./modules/postcode-jp";

const repositories = {
  // posts: DummyPostsRepository,
  "user-account": UserAccountRepository,
  "service-accounts": ServiceAccountsRepository,
  organizations: OrganizationsRepository,
  "asig-projects": AsigProjectsRepository,
  "monitoring-devices": MonitoringDevicesRepository,
  "mabeeeml-monitoring-devices": MabeeemlMonitoringDevicesRepository,
  "monitoring-targets": MonitoringTargetsRepository,
  "monitoring-settings": MonitoringSettingsRepository,
  "ascmu-monitoring-settings": AscmuMonitoringSettingsRepository,
  "contact-monitoring-event-rules": ContactMonitoringEventRulesRepository,
  "notification-recipients": NotificationRecipients,
  billings: BilingsRepository,
  "ascmu-subscriptions": AscmuSubscriptionsRepository,
  "sign-up": SignUpRepository,
  "reset-password": ResetPasswordRepository,
  "postcode-jp": PostcodeJpRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
